/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FileBoundaryCondition } from "./FileBoundaryCondition";
import {
  FileBoundaryConditionFromJSON,
  FileBoundaryConditionFromJSONTyped,
  FileBoundaryConditionToJSON,
  FileBoundaryConditionToJSONTyped,
} from "./FileBoundaryCondition";

/**
 *
 * @export
 * @interface PaginatedFileBoundaryConditionList
 */
export interface PaginatedFileBoundaryConditionList {
  /**
   *
   */
  count: number;
  /**
   *
   */
  next?: string | null;
  /**
   *
   */
  previous?: string | null;
  /**
   *
   */
  results: Array<FileBoundaryCondition>;
}

/**
 * Check if a given object implements the PaginatedFileBoundaryConditionList interface.
 */
export function instanceOfPaginatedFileBoundaryConditionList(
  value: object
): value is PaginatedFileBoundaryConditionList {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function PaginatedFileBoundaryConditionListFromJSON(
  json: any
): PaginatedFileBoundaryConditionList {
  return PaginatedFileBoundaryConditionListFromJSONTyped(json, false);
}

export function PaginatedFileBoundaryConditionListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PaginatedFileBoundaryConditionList {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(FileBoundaryConditionFromJSON),
  };
}

export function PaginatedFileBoundaryConditionListToJSON(
  json: any
): PaginatedFileBoundaryConditionList {
  return PaginatedFileBoundaryConditionListToJSONTyped(json, false);
}

export function PaginatedFileBoundaryConditionListToJSONTyped(
  value?: PaginatedFileBoundaryConditionList | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(FileBoundaryConditionToJSON),
  };
}
